import { render, staticRenderFns } from "./ArtisioModal.vue?vue&type=template&id=8b2c5c96&scoped=true"
import script from "./ArtisioModal.vue?vue&type=script&lang=js"
export * from "./ArtisioModal.vue?vue&type=script&lang=js"
import style0 from "./ArtisioModal.vue?vue&type=style&index=0&id=8b2c5c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c5c96",
  null
  
)

export default component.exports